import { render, staticRenderFns } from "./Dimensions.vue?vue&type=template&id=018997e7&scoped=true"
import script from "./Dimensions.vue?vue&type=script&lang=js"
export * from "./Dimensions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018997e7",
  null
  
)

export default component.exports